import { Box, Typography } from '@mui/material';

import { UserProfileMenu } from '@/components/UserProfileMenu';
import { IS_V2_WRITE_ENABLED } from '@/configs/v2Write';
import { LogsMode, useLogsMode } from '@/features/logsMode';

import s from './TimesheetHeader.module.scss';

export const TimesheetHeader = () => {
  const mode = useLogsMode();

  return (
    <Box component="header" className={s.header}>
      <div className={s.brand}>
        <Typography variant="h6" component="h1" className={s.title}>
          Timelog
        </Typography>
        {mode === LogsMode.v2 && (
          <span
            className={s.badge}
            title={
              IS_V2_WRITE_ENABLED
                ? 'Новый учёт: логи хранятся у нас, а не в Яндекс Трекере'
                : 'Новый учёт пока только для просмотра: логи пишем в Яндекс Трекер'
            }
          >
            {IS_V2_WRITE_ENABLED ? 'v2' : 'v2 · просмотр'}
          </span>
        )}
      </div>
      <UserProfileMenu />
    </Box>
  );
};
